// extracted by mini-css-extract-plugin
module.exports = {"mdxInlineComment":"mdx-inline-comment-module--mdx-inline-comment--3zyD_"};